import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Perspective } from './pages/Perspective';
import { Purpose } from './pages/Purpose';
import { Principles } from './pages/Principles';
import { Practice } from './pages/Practice';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
export function AppRouter() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
        <Route path="/perspective" element={<Perspective data-id="element-8" />} data-id="element-7" />
        <Route path="/purpose" element={<Purpose data-id="element-10" />} data-id="element-9" />
        <Route path="/principles" element={<Principles data-id="element-12" />} data-id="element-11" />
        <Route path="/practice" element={<Practice data-id="element-14" />} data-id="element-13" />
        <Route path="/contact" element={<Contact data-id="element-16" />} data-id="element-15" />
        <Route path="/terms" element={<Terms data-id="element-18" />} data-id="element-17" />
        <Route path="/privacy" element={<Privacy data-id="element-20" />} data-id="element-19" />
      </Routes>
    </BrowserRouter>;
}